<template>
  <div class="lg:px-33 md:px-33 sm:px-0 h-full">
    <div
      v-show="step === 'register'"
      class="flex flex-col-reverse sm:flex-col w-full h-auto md:h-full"
    >
      <div class="flex flex-col md:flex-row px-6 lg:px-0 justify-center h-full">
        <register-form
          @set-registration-detail="setRegistrationDetail($event)"
          @registered="handleRegistered($event)"
          @next-step="step = 'firm'"
          class="w-full md:w-6/12"
        />
        <register-info class="w-full hidden md:flex md:w-6/12" />
      </div>
    </div>
    <div
      v-show="step === 'firm'"
      class="flex flex-col-reverse sm:flex-col w-full h-auto md:h-full"
    >
      <div class="flex flex-col md:flex-row px-6 lg:px-0 justify-center h-full">
        <firm-info
          @set-registration-detail="setRegistrationDetail($event)"
          @submit="submit"
          class="w-full md:w-6/12"
          @back="step = 'register'"
          :initial-company-name="registrationDetails.company_name"
          @update:company-name="firmName = $event"
        />
        <firm-info-graphic
          :firm-name="firmName"
          class="w-full hidden md:block md:w-6/12"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RegisterForm from "../components/RegisterForm.vue"
import RegisterInfo from "../components/RegisterInfo.vue"
import FirmInfo from "../components/RegistrationStep/FirmInfo.vue"
import FirmInfoGraphic from "../components/RegistrationStep/FirmInfoGraphic.vue"
import EventAnalytics from "../../helpers/EventAnalytics"

export default {
  name: "Registration",

  components: {
    RegisterForm,
    RegisterInfo,
    FirmInfo,
    FirmInfoGraphic,
  },

  data() {
    return {
      registrationDetails: {},
      redirect_url: "",
      step: "register",
      firmName: "",
      userId: null,
    }
  },

  methods: {
    setRegistrationDetail(event) {
      Object.assign(this.registrationDetails, event)
    },

    handleRegistered({ redirect_url, company_name, user_id }) {
      if (redirect_url) {
        this.redirect_url = redirect_url
      }
      if (company_name) {
        this.registrationDetails.company_name = company_name
      }
      if (user_id) {
        this.userId = user_id
        EventAnalytics.init({ userId: user_id })
      }

      const _hsq = (window._hsq = window._hsq || [])
      _hsq.push([
        "trackCustomBehavioralEvent",
        {
          name: "fc_new_trial",
          properties: {
            company_name,
          },
        },
      ])
    },

    sendRegisterEventToGoogle() {
      try {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: "free_trial_signup",
        })

        const is_not_icp = ["Just me", "2 to 4"].includes(this.registrationDetails.firm_size)
        if (!is_not_icp) {
          window.dataLayer.push({
            event: "icp_signup",
          })
        }
      } catch (e) {
        // ignore error
        console.error(e)
      }
    },

    submit() {
      this.sendRegisterEventToGoogle()

      if (this.redirect_url && this.redirect_url !== "/home") {
        window.location.href = this.redirect_url
        return
      }

      window.location.href = "/home?onboarding=1"
    },
  },
}
</script>
